import * as React from "react"
import {Box, Chip} from "@mui/material"


export default function tagColumn() {
    return [{
        name: "tag", label: "Tags",
        options: {
            display: "excluded",
            customBodyRowRender: value => value || "Empty"
        }
    }, {
        name: "tag", label: "Tags",
        options: {
            filter: false,
            setCellProps: () => ({ sx: { textAlign: "center" } }),
            customBodyRowRenderLite: value => <Box
                display="flex"
                justifyContent="center"
                gap={.5}
                flexWrap="wrap"
            >
                <Box display="flex" flexWrap="wrap" gap={1}>
                    {value.map((item, index) => <Chip
                        key={index}
                        label={item.split(' ').filter(char => !!char).join(' ')}
                        color={"success"}
                    />)}
                </Box>
            </Box>
        }
    }]
}